import {AppApi} from 'store/customer/api';
import {
    PlaceholderFace,
    normalizePlaceholderFaceImage,
} from 'components/customer/RoomPlanner/entity/PlaceholderFace';

type PlaceholderFaceApiItem = Omit<PlaceholderFace, 'image'> & {
    image?: unknown;
    imageUrl?: string;
    image_url?: string;
};

type PlaceholderFacesResponse =
    | PlaceholderFaceApiItem[]
    | {
          placeholder_faces?: PlaceholderFaceApiItem[];
          items?: PlaceholderFaceApiItem[];
          data?: PlaceholderFaceApiItem[];
      };

const toPlaceholderFaceList = (
    response: PlaceholderFacesResponse
): PlaceholderFaceApiItem[] => {
    if (Array.isArray(response)) return response;
    return response.placeholder_faces ?? response.items ?? response.data ?? [];
};

export const placeholderFaceApi = AppApi.injectEndpoints({
    endpoints: (builder) => ({
        /**
         * Customer-facing placeholder list (mirrors getQuickProducts).
         * Used by RoomPlanner Appliances / QuickAdd tiles.
         */
        getPlaceholderFaces: builder.query<PlaceholderFace[], void>({
            // Same list endpoint the admin screen uses, presented for the
            // customer. The menu needs the whole catalogue, not one page.
            query: () => ({
                url: 'room-planner/placeholder',
                params: {
                    page_size: 1000,
                    sort_orders: 'category ASC, name ASC',
                },
            }),
            transformResponse: (response: PlaceholderFacesResponse) =>
                toPlaceholderFaceList(response).map((face) => ({
                    ...face,
                    image: normalizePlaceholderFaceImage(
                        face.image ?? face.imageUrl ?? face.image_url
                    ),
                })),
            providesTags: ['PlaceholderFaces'],
        }),
    }),
});

export const {useGetPlaceholderFacesQuery} = placeholderFaceApi;
